export default "__VITE_ASSET__BRflhdSa__"